import { ProductCard } from './ProductCard';

export const ProductGrid = ({ products, loading, columns = 4 }) => {
  if (loading) {
    return (
      <div className="product-grid">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="aspect-product bg-[#F5F4F2] mb-4" />
            <div className="h-4 bg-[#F5F4F2] w-3/4 mb-2" />
            <div className="h-4 bg-[#F5F4F2] w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="text-center py-16">
        <p className="text-[#6B6A68] font-serif text-xl">Aucun produit trouvé</p>
        <p className="text-sm text-[#6B6A68] mt-2">
          Essayez de modifier vos filtres
        </p>
      </div>
    );
  }

  return (
    <div className="product-grid" data-testid="product-grid">
      {products.map((product) => (
        <ProductCard key={product.product_id} product={product} />
      ))}
    </div>
  );
};
